'use client';
import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import Script from 'next/script';

const GA_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;

export default function GoogleAnalytics() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!GA_ID || typeof window === 'undefined' || !window.gtag) return;
    const url = pathname + (searchParams?.toString() ? `?${searchParams?.toString()}` : '');
    window.gtag('event', 'page_view', { page_path: url });
  }, [pathname, searchParams]);

  if (!GA_ID) return null;

  return (
    <>
      <Script data-component-id="src/components/GoogleAnalytics.tsx:22:6" data-component-path="src/components/GoogleAnalytics.tsx" data-component-line="22" data-component-end-line="25" data-component-file="GoogleAnalytics.tsx" data-component-name="Script" data-component-content="%7B%22elementName%22%3A%22Script%22%7D"
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
        strategy="afterInteractive"
      />
      <Script data-component-id="src/components/GoogleAnalytics.tsx:26:6" data-component-path="src/components/GoogleAnalytics.tsx" data-component-line="26" data-component-end-line="33" data-component-file="GoogleAnalytics.tsx" data-component-name="Script" data-component-content="%7B%22elementName%22%3A%22Script%22%2C%22id%22%3A%22google-analytics%22%7D" id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_ID}', { page_path: window.location.pathname });
        `}
      </Script>
    </>
  );
}
